import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
  autoSleep: 60,
  force3D: true,
  nullTargetWarn: false,
  trialWarn: false,
  units: {
    left: "%",
    top: "%",
    rotation: "rad",
  },
});

export class shopCartDrawer {
  constructor(el) {
    this.el = el;
    this.menuBox = el.querySelectorAll("[data-section-menu-box]");
    this.bgBox = el.querySelectorAll("[data-section-bg-box]");

    this.timeline = null;
  }

  Reset() {
    this.productCard = this.el.querySelectorAll("[data-section-product-card]");
    gsap.set(this.el, { x: "0%" });
    gsap.set(this.menuBox, { x: "0%" });
    gsap.set(this.bgBox, { opacity: 0 });
    this.timeline != null ? this.timeline.kill() : "";
  }

  Open() {
    this.Reset();
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.set(
      this.el,
      {
        x: "-100%",
      },
      "beforeOpen"
    );

    this.timeline.to(
      this.bgBox,
      {
        opacity: 1,
        duration: 0.3,
      },
      "open"
    );
    this.timeline.to(
      this.menuBox,
      {
        x: "-100%",
        duration: 0.3,
      },
      "open"
    );
  }

  Close() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.to(
      this.bgBox,
      {
        opacity: 0,
        duration: 0.3,
      },
      "close"
    );
    this.timeline.to(
      this.menuBox,
      {
        x: "0%",
        duration: 0.3,
      },
      "close"
    );

    this.timeline.set(
      this.el,
      {
        x: "0%",
      },
      "afterClose"
    );
  }
}
